import React from 'react';
import { Alert, Spin } from 'antd';
import Glp1BridgeProviderAccessGate from './Glp1BridgeProviderAccessGate';
import './Glp1BridgeProviderAccess.css';

export default function Glp1BridgeProviderAccessOverlay({
  accessError,
  accessLoading,
  checkingCopy = 'If this browser already has valid provider access, this resource will unlock automatically.',
  children,
  onVerified,
  previewClassName = '',
  previewTestId = 'glp1-locked-resource-preview',
}) {
  const previewClasses = ['glp1-locked-resource-preview', previewClassName].filter(Boolean).join(' ');

  return (
    <div className="glp1-access-overlay-shell" data-testid="glp1-access-overlay-shell">
      <div
        className="glp1-access-dock glp1-access-dock--centered"
        data-testid="glp1-access-overlay-dock"
        aria-live="polite"
      >
        {accessLoading ? (
          <section className="glp1-access-checking" role="status" aria-label="Checking provider access">
            <Spin size="small" />
            <div>
              <div className="glp1-access-checking-title">Checking provider access...</div>
              <p className="glp1-access-checking-copy">{checkingCopy}</p>
            </div>
          </section>
        ) : (
          <>
            {accessError ? (
              <Alert
                type="warning"
                showIcon
                message={accessError}
                className="glp1-access-alert"
              />
            ) : null}
            <Glp1BridgeProviderAccessGate onVerified={onVerified} />
          </>
        )}
      </div>

      <div
        className={previewClasses}
        data-testid={previewTestId}
        aria-hidden="true"
        inert=""
      >
        {children}
      </div>
    </div>
  );
}
